import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Observable } from 'rxjs';
import { Globals } from '../models/globals.model';
import { SseService } from './sse-service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MLService {

  apiUri: string;
  graphUri: string;
  flowsheetUri: string;

  amlWorkspaceListApi = "AML/GetAMLWorkspaces";
  amlWorkspaceApi = "Azure/GetResourcesByTypeAndName";
  createMLWorkspace = "AML/CreateAMLWorkspace";
  locationApi = "Azure/GetAllRegions";
  resourceGroupsApi = "Azure/GetResourceGroups";
  keyVaultsApi = "Azure/GetKeyVaults";
  storageAccountsApi = "Azure/GetStorageAccounts";
  containerRegistriesApi = "Azure/GetContainerRegistries";
  applicationInsightsApi = "Azure/GetApplicationInsights";
  saveModelMasterDataApi = "api/SaveModelMasterData";
  getBusinessFunctionTypesApi = "api/ModelManagement/GetBusinessFunctionTypes";
  deleteModelApi = "api/ModelManagement/DeleteModelMasterData";
  getModelListApi = "api/GetModelList";
  getModelParametersApi = "api/GetModelParameter";
  getParameterListApi = "api/GetParameterList";
  getConfigParameters = "api/GetModelParameter";
  getDataSourcesApi = "api/FlowsheetBuilder/GetDataSources";
  getDataSourceParametersApi = "api/FlowsheetBuilder/GetDataSourceParameters";
  executeModelUrlApi = "api/RunModel";
  getSimulationRunApi = "api/GetSimulationResult";
  saveConfigureModelApi = "api/SaveModelConfigureData";
  getTokenApi = "api/ModelManagement/GetToken";
  getBaseModelTypesApi = "api/ModelManagement/GetBaseModelTypes";
  getAllSecrets = "api/GetAllSecrets";
  getAuthDetails = "api/GetAuthDetails";
  saveModelApi = "api/GetModelConfigurationParameterByModelName";
  saveFormDataUrl: string = "api/SaveModelConfiguration";
  authCodeApi: string = "api/authCode";
  apimAuthCodeApi: string = "api/apimAuthCode";
  modelConfigurationApi: string = "api/GetModelConfiguration";
  saveModelData = 'api/uploadModel';

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient,
    private readonly _zone: NgZone, private readonly _sseService: SseService,
    public globalService: GlobalService,) {
    this.apiUri = this.globals.config.modelManagementApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
    this.flowsheetUri = this.globals.config.flowsheetApi_client_resourceUri;
  }

  getParameterList(modelName, modelConfigrationId) {
    let params = { modelName: modelName, modelConfigrationId: modelConfigrationId };
    return this.http.get(this.apiUri + this.getParameterListApi, {
      params: params
    });
  }

  getConfigParameter(modelId) {
    return this.http.get(this.apiUri + this.getConfigParameters + "/" + modelId);
  }

  getConfigParameterWithDetails(name, modelConfigurationId) {
    return this.http.get(this.apiUri + this.getConfigParameters + "/" + name + "/" + modelConfigurationId);
  }

  getAmlWorkspaces(resourceGroup) {
    let params = { ResourceGroupName: resourceGroup };
    return this.http.get(this.apiUri + this.amlWorkspaceListApi, {
      params: params
    });
  }
  getAmlWorkspace(ResourceGroup, resourceName) {
    let params = { ResourceGroup: ResourceGroup, resourceType: "Microsoft.MachineLearningServices/workspaces", resourceName: resourceName };
    return this.http.get(this.apiUri + this.amlWorkspaceApi, {
      params: params
    });
  }
  getResourceGroups() {
    return this.http.get(this.apiUri + this.resourceGroupsApi);
  }
  getLocations() {
    return this.http.get(this.apiUri + this.locationApi);
  }
  getKeyVaults(resourceGroup) {
    let params = { resourceGroup: resourceGroup };
    return this.http.get(this.apiUri + this.keyVaultsApi, {
      params: params
    });
  }
  getStorageAccounts(resourceGroup) {
    let params = { resourceGroup: resourceGroup };
    return this.http.get(this.apiUri + this.storageAccountsApi, {
      params: params
    });
  }
  getContainerRegistries(resourceGroup) {
    let params = { resourceGroup: resourceGroup };
    return this.http.get(this.apiUri + this.containerRegistriesApi, {
      params: params
    });
  }
  getApplicationInsights(resourceGroup) {
    let params = { resourceGroup: resourceGroup };
    return this.http.get(this.apiUri + this.applicationInsightsApi, {
      params: params
    });
  }

  getBusinessFunctionTypes() {
    return this.http.get(this.apiUri + this.getBusinessFunctionTypesApi);
  }

  getToken() {
    return this.http.get(this.apiUri + this.getTokenApi);
  }

  getBaseModelTypes() {
    return this.http.get(this.apiUri + this.getBaseModelTypesApi);
  }

  getAllSecretsList() {
    return this.http.get(this.apiUri + this.getAllSecrets);
  }

  getAuthDetailsList() {
    return this.http.get(this.apiUri + this.getAuthDetails);
  }

  CreateMLWorkspace(worksapceDetail) {
    return this.http.post(this.apiUri + this.createMLWorkspace, worksapceDetail);
  };

  saveModelMasterData(modelMasterData) {
    return this.http.post(this.apiUri + this.saveModelMasterDataApi, modelMasterData);
  };

  deleteModelMasterData(modelId, ModelConfigrationId) {
    let params = { modelId: modelId, ModelConfigrationId: ModelConfigrationId };
    return this.http.delete(this.apiUri + this.deleteModelApi, {
      params: params
    });
  }

  getModelList() {
    return this.http.get(this.apiUri + this.getModelListApi);
  }

  getModelParameters(modelId) {
    return this.http.get(this.apiUri + this.getModelParametersApi + "/" + modelId);
  }

  getDataSources() {
    return this.http.get(this.flowsheetUri + this.getDataSourcesApi);
  }

  getDataSourceParameters(dataSourceId) {
    let params = { dataSourceId: dataSourceId };
    return this.http.get(this.flowsheetUri + this.getDataSourceParametersApi, {
      params: params
    });
  }

  redirectTo(url) {
    window.location.href = url;
  }

  executeModel(dataSourceId) {
    return this.http.post(this.apiUri + this.executeModelUrlApi, dataSourceId);
  }

  getSimulationRunReport(runId) {
    return Observable.create(observer => {
      const eventSource = this._sseService.getEventSource(this.apiUri + this.getSimulationRunApi + "?modelRunId=" + runId);
      eventSource.onmessage = event => {
        this._zone.run(() => {
          let returnData = JSON.parse(event.data);
          if (returnData.simulationRunStatus) {
            eventSource.close();
          }
          observer.next(returnData);
        });
      };
    });
  }

  saveConfigureModel(saveConfigureModel) {
    return this.http.post(this.apiUri + this.saveConfigureModelApi, saveConfigureModel);
  }

  saveData(functionData) {
    return this.http.post(this.apiUri + this.saveFormDataUrl, functionData);
  }

  saveModel(configureModelName) {
    let params = { modelName: configureModelName };
    return this.http.get(this.apiUri + this.saveModelApi, {
      params: params
    });
  }

  geAuthCode() {
    return this.http.get(this.apiUri + this.authCodeApi);
  }

  listOfModel(accessTokenModel): any {
    let modelsListUrl = this.globals.config.modelListULR;
    return this.http.get(modelsListUrl, accessTokenModel);
  }

  deleteModelData(selModelDeleteId, httpOptions) {
    let deleteModelUrl = this.globals.config.deleteModelURL + selModelDeleteId;
    return this.http.delete(deleteModelUrl, httpOptions);
  }

  deleteEachModelData(modelId, httpOptions) {
    let deleteEachModelUrl = this.globals.config.deleteModelURL + modelId;
    return this.http.delete(deleteEachModelUrl, httpOptions);
  }

  apimAuthCodeData() {
    const httpOptions = { headers: this.globalService.phtHeaders };
    let apimAuthCodeUrl = this.apiUri + this.apimAuthCodeApi;
    return this.http.get(apimAuthCodeUrl, httpOptions);
  }

  modelsExecData(modelsExecUrl, formValue, httpOptions) {
    return this.http.post(this.apiUri + modelsExecUrl, formValue, httpOptions);
  }

  getModelConfigurationData() {
    return this.http.get(this.apiUri + this.modelConfigurationApi);
  }

  saveModelFormData(formData) {
    return this.http.post(this.apiUri + this.saveModelData, formData);
  };
}
